import { Component, OnInit, OnDestroy, Compiler, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { AlertService, SDGComponentService, ResultService } from '../../_services/index';
import { SDGComponent, Result, ResultData } from '../../_models/index';
import { Observable } from 'rxjs/Observable';
import { Subscription } from 'rxjs/Subscription';
import { environment } from '../../../environments/environment';
import * as GlobalVariables from '../globals/globals';
import * as $ from 'jquery';
import { MatDialog } from '@angular/material/dialog';
import { MatRadioChange } from '@angular/material';
import { SaveDiscardDialogComponent } from '../save-discard-dialog/save-discard-dialog.component';
import { and } from '@angular/router/src/utils/collection';

var COMP = environment.component.gender;
var testmode = environment.testmode;

interface ValWt {
  value?: string;
  wt: number;
  detail_value?: string;
}

@Component({
  selector: 'app-gender-quest',
  templateUrl: './gender-quest.component.html',
  styleUrls: ['./gender-quest.component.css']
})

export class GenderQuestComponent implements OnInit, OnDestroy {
  lang = 1;
  src_pdf: string;
  testmode = (environment.testmode || localStorage.getItem('editmode')=='1');
  admin_url = environment.url_django;
  loading = false;
  submit_attempted = false;
  team : number;
  is_partial : any = "false";
  team_pool_questions: number;
  last_saved: any;
  grp : number = 0;
  sdgcomponent$ : Observable<SDGComponent>;
  results$ : Observable<any>;
  subscription1:Subscription;
  subscription2:Subscription;
  gender_comp : any;
  answers: Object = {};
  questions: Object = {};
  values : Array<ValWt> = [];
  option1 : Array<ValWt> = [];
  option2 : Array<ValWt> = [];
  option3 : Array<ValWt> = [];
  option4 : Array<ValWt> = [];
  option5 : Array<ValWt> = [];
  option6 : Array<ValWt> = [];
  option : Array<Array<ValWt>> = [[]];
  quesid_grp : Array<Array<Number>>=[[]];
  @ViewChild('f') f: any;
  guideText: string = '';
  guidePanelOpen: boolean = false;
  guideLinks: { url: string, label: string }[] = [];
  rad_btn_change : boolean = false;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private sdgComponentService: SDGComponentService,
    private alertService: AlertService,
    private resultService: ResultService,
    private _compiler: Compiler,
    public matdialog: MatDialog){}

  canDeactivate():Observable<boolean> {

      const questcomp = this;

      const obs = Observable.create(function(observer){

      var form_dirty = questcomp.f.dirty;
      //form_dirty = true;//hardcoded to show save dialog, needs to be worked on, not getting dirty on change in radio button, working with textbox in status-quest
      if (form_dirty){
        const dialogRef = questcomp.matdialog.open(SaveDiscardDialogComponent, { width: '400px' });
        dialogRef.afterClosed().subscribe(result => {
         if(result=='save'){
          questcomp.is_partial='true';
          questcomp.submitForm(true);
          Object.keys(questcomp.f.controls).forEach(control => {
              questcomp.f.controls[control].markAsPristine();
          });
          $(".header_active").removeClass("header_active")
          $(".gender-click").addClass("header_active")
          observer.next(false);
          observer.complete();
         }
         else if(result=='discard'){
          observer.next(true);
          observer.complete();
         }
       });
      }
      else{
          observer.next(true);
          observer.complete();
      }

      });
      return obs;
    }

  radioChange($event: MatRadioChange) {
    //If radio button changes
      this.f.form.markAsDirty();
      // if ($event.source.name === 'radioOpt1') {
      //     // Do whatever you want here
      // }
  }
  
  ngOnInit() {
    this._compiler.clearCache();
    $(".header_active").removeClass("header_active")
    $(".gender-click").addClass("header_active")
    
    this.lang = GlobalVariables.findTranslationOptionsIndex(window);

    if (window.location.href.indexOf("/fr/") > -1) {
      this.src_pdf="./assets/SDG-PSS-guidelines-2019-FR.pdf";}
    else if (window.location.href.indexOf("/es/") > -1){
      this.src_pdf="./assets/SDG-PSS-guidelines-2019-V3.pdf";}
    else {
      this.src_pdf="./assets/SDG-PSS-guidelines-2019-V3.pdf";}

    this.results$ = this.resultService.getResultData(COMP);
    this.sdgcomponent$ = this.sdgComponentService.getAll(COMP);
    this.subscription1 = this.sdgcomponent$
    .subscribe(data => {
        //get my user's team
        let user: any ;
        if (localStorage.getItem('currentUserId')) {
          user = JSON.parse(localStorage.getItem('currentUserId'));
          this.team = user.team;
        }
        this.team_pool_questions = 0;

        var categories = data.category;
        var ordered_categories = [];
        var cl = categories.length;

        for(var i = 0; i< cl; i++){
          ordered_categories[categories[i].order-1] = categories[i];
        }

        for(var i = 0; i< cl; i++){
          var oc_sc = ordered_categories[i].sub_category;
          var oc_osc = [];
          for(var j = 0; j< oc_sc.length; j++){
            oc_osc[oc_sc[j].order-1] = oc_sc[j];
          }
          ordered_categories[i].sub_category = oc_osc;
        }

        for(var i = 0; i< cl; i++){
          var oc_sc = ordered_categories[i].sub_category;
          for(var j = 0; j< oc_sc.length; j++){
            var qc = oc_sc[j].question_category;
            var oqc = [];
            for(var k = 0; k < qc.length; k++){
              oqc[qc[k].order-1] = qc[k];
            }
            ordered_categories[i].sub_category[j].question_category = oqc;
          }
        }

        for(var i = 0; i< cl; i++){
          var oc_sc = ordered_categories[i].sub_category;
          for(var j = 0; j< oc_sc.length; j++){
            var qc = oc_sc[j].question_category;
            for(var k = 0; k < qc.length; k++){
              var q = qc[k].question;
              var oq = [];
              for(var l = 0; l < q.length; l++){
                oq[q[l].order-1] = q[l];
              }
              for(var l = 0; l < oq.length; l++){
                if(!oq[l]){
                  oq.splice(l,1);
                }
              }
              ordered_categories[i].sub_category[j].question_category[k].question = oq;
            }
          }
        }
        data.category = ordered_categories;
        //Assign gender question
        this.gender_comp = data;
        for(var i = 0; i< this.gender_comp.category.length; i++){
          for(var j = 0; j< this.gender_comp.category[i].sub_category.length; j++){
            let bg_color_counter = 0;
            for(var k = 0; k< this.gender_comp.category[i].sub_category[j].question_category.length; k++){

              //Set the class either light blue or dark blue
              if (this.gender_comp.category[i].sub_category[j].question_category[k].visible){
                this.gender_comp.category[i].sub_category[j].question_category[k].k = bg_color_counter;
                bg_color_counter++;
              }

              for(var l = 0; l< this.gender_comp.category[i].sub_category[j].question_category[k].question.length; l++){

                var question_cat = this.gender_comp.category[i].sub_category[j].question_category[k];
                var question = question_cat.question[l];
                var question_id = question.id;
                var q_qgroup = question.question_grp;
                var question_text = question.question_text;
                var op1 = question_cat.option1;
                var op2 = question_cat.option2;
                var op3 = question_cat.option3;
                var op4 = question_cat.option4;
                var op5 = question_cat.option5;
                var op6 = question_cat.option6;
                var qcat_qtype = question_cat.question_type;

                if(data['category'][i].sub_category[j].question_category[k].question_type != "Empty"){

                  let default_option = question_cat.default_option;
                  default_option = parseInt(default_option)-1;
                  let default_value = '';
                  if(question_cat.default_value)
                    default_value = question_cat.default_value;
                  else if(question.default_value)
                    default_value = question.default_value;

                //initialize questions into groups
                if(this.quesid_grp[q_qgroup]){
                  this.quesid_grp[q_qgroup].push(question_id);
                  this.gender_comp.category[i].sub_category[j].question_category[k].question[l].grp=false;
                }
                else{
                  this.quesid_grp[q_qgroup]=[];
                  this.quesid_grp[q_qgroup].push(question_id);
                  this.gender_comp.category[i].sub_category[j].question_category[k].question[l].grp=true;
                }

                if (qcat_qtype=='Tabular'){
                  var value=default_value;
                  if(testmode)
                    value=getRndInteger(1,10);
                  this.values[question_id] = {'value':value, 'wt':1, 'detail_value':''};

                  var pattern = /.*/;//anything
                  var is_pattern = true;
                  var pattern_error = '';
                  if(question.question_type_numeric=="True"){
                      pattern = /^\d+$/;
                      pattern_error = '+ve Number'
                      }

                  question.pattern=pattern;
                  question.is_pattern=is_pattern;
                  question.pattern_error=pattern_error;
                  this.questions[question_id] = question;
                }
                else if (qcat_qtype=='Radetail1'){
                  this.option1[question_id] = {'value':op1, 'wt':1, 'detail_value':''};
                  this.option2[question_id] = {'value':op2, 'wt':2, 'detail_value':''};
                  this.option=[this.option1,this.option2];
                  this.values[question_id] = this.option[default_option][question_id];
                }
                else if (qcat_qtype=='Radetail2'){
                  this.option1[question_id] = {'value':op1, 'wt':1, 'detail_value':''};
                  this.option2[question_id] = {'value':op2, 'wt':2, 'detail_value':''};
                  this.option3[question_id] = {'value':op3, 'wt':3, 'detail_value':''};
                  this.option=[this.option1,this.option2,this.option3];
                  this.values[question_id] = this.option[default_option][question_id];
                }
                else if (qcat_qtype=='RadioButtons'){
                  this.option1[question_id] = {'value':op1, 'wt':1, 'detail_value':''};
                  this.option2[question_id] = {'value':op2, 'wt':2, 'detail_value':''};
                  this.option3[question_id] = {'value':op3, 'wt':3, 'detail_value':''};
                  this.option4[question_id] = {'value':op4, 'wt':4, 'detail_value':''};
                  this.option=[this.option1,this.option2,this.option3,this.option4];
                  if(question_text == 'Other')
                    this.values[question_id] = {'value':default_value, 'wt':0, 'detail_value':''};
                  else
                    this.values[question_id] = this.option[default_option][question_id];
                }
                else if (qcat_qtype=='RadioButtons3'){
                  this.option1[question_id] = {'value':op1, 'wt':1, 'detail_value':''};
                  this.option2[question_id] = {'value':op2, 'wt':2, 'detail_value':''};
                  this.option3[question_id] = {'value':op3, 'wt':3, 'detail_value':''};
                  this.option=[this.option1,this.option2,this.option3];
                  if(question_text == 'Other')
                    this.values[question_id] = {'value':default_value, 'wt':0, 'detail_value':''};
                  else
                    this.values[question_id] = this.option[default_option][question_id];
                }
                else if (qcat_qtype=='Radother'){
                  this.option1[question_id] = {'value':op1, 'wt':1, 'detail_value':''};
                  this.option2[question_id] = {'value':op2, 'wt':2, 'detail_value':''};
                  this.option3[question_id] = {'value':op3, 'wt':3, 'detail_value':''};
                  this.option4[question_id] = {'value':op4, 'wt':4, 'detail_value':''};
                  this.option5[question_id] = {'value':op5, 'wt':5, 'detail_value':''};
                  this.option6[question_id] = {'value':default_value, 'wt':6, 'detail_value':''};
                  this.option=[this.option1,this.option2,this.option3,this.option4,this.option5,this.option6];
                  this.values[question_id] = this.option[default_option][question_id];
                  if(question_text == 'Other')
                    this.values[question_id] = {'value':default_value, 'wt':0, 'detail_value':''};
                  else
                    this.values[question_id] = this.option[default_option][question_id];
                }
                else if (qcat_qtype=='TextField' || qcat_qtype=='NumberField'){
                  this.values[question_id] = {'value':default_value, 'wt':0, 'detail_value':''};
                }
              } else {
                  //if question type in question category is "Empty"
                  this.option1[question.id] = <ValWt>{'value':question.option1, 'wt':1};
                  this.option2[question.id] = <ValWt>{'value':question.option2, 'wt':2};
                  this.option3[question.id] = <ValWt>{'value':question.option3, 'wt':3};
                  this.option4[question.id] = <ValWt>{'value':question.option4, 'wt':4};
                  this.option=[this.option1,this.option2,this.option3,this.option4];
                  //if question type in question category is "Empty"
                  if (question.team==this.team){
                    this.team_pool_questions = this.team_pool_questions + 1;
                    if (question.question_options=='1') //1 means Input field
                      this.values[question.id]= <ValWt>{'value':'', 'wt':1};
                    else
                      this.values[question.id] = this.option[0][question.id];
                  }
                }
              }
            }
          }
        }
        this.subscription2 = this.results$
        .subscribe(
          data1 => {
              for(var idx=0;idx<data1.length;idx++){
                var res = data1[idx];
                if (!this.last_saved){
                    this.last_saved = new Date(res.last_saved);
                  }
                if (this.option[res.value_weight-1] && this.option[res.value_weight-1][res.question]){
                  this.values[res.question] = this.option[res.value_weight-1][res.question];
                }else {
                  this.values[res.question] = <ValWt>{'value':res.value, 'wt':1};
                }
              }
          },
          error => {
            this.alertService.error(error);
          });
      },
      error => {
        this.alertService.error(error);
      });
}

  option_translation(option_text, lang){
    if (lang == 1 || option_text == null)
      return option_text;
    let option_key = option_text.trim().toLowerCase();
    if (option_key in GlobalVariables.option_translations[lang])
      return GlobalVariables.option_translations[lang][option_key];
    return option_text;
  }

empty_objects(objects_arrays){
  for (var j=0; j<objects_arrays.length; j++){
    var props = Object.getOwnPropertyNames(objects_arrays[j]);
    for (var i = 0; i < props.length; i++) {
      delete objects_arrays[j][props[i]];
    }
  }
}

empty_array_of_arrays(arr_of_arr){
  for (var j=0; j<arr_of_arr.length; j++){
  arr_of_arr[j] = null;
  }
  arr_of_arr = null;
}

ngOnDestroy() {
  this.empty_objects([this.gender_comp,this.answers,this.questions]);
  this.empty_array_of_arrays(this.option);
  this.empty_array_of_arrays(this.quesid_grp);
  this.values = null;
  this.option1 = null;
  this.option2 = null;
  this.option3 = null;
  this.option4 = null;
  this.option5 = null;
  this.option6 = null;

  if(this.subscription1)
    this.subscription1.unsubscribe();
  if(this.subscription2)
    this.subscription2.unsubscribe();
  }

submitForm(valid){
  let user;
  if (localStorage.getItem('currentUserId')) {
      user = localStorage.getItem('currentUserId');
      user = JSON.parse(user);
      if(!user.can_edit){
        this.alertService.error("Sorry you are not authorized to save/submit. Please contact your country focal point for the rights");
        window.scroll(0,0);
        return;
      }
  }
  if(this.is_partial=="false")
    this.submit_attempted = true;
  if(!valid && this.is_partial=="false") {
    this.alertService.error("Please fill all required fields to submit the form. Or use save option for incomplete form");
    window.scroll(0,0);
    return;
  }
  this.loading = true;

  for(var i = 0; i< this.values.length; i++){
    if (typeof(this.values[i]) != "undefined"){
      this.answers[i]={
        question: i,
        value: this.values[i].value,
        value_weight: this.values[i].wt
      };
    }
  }
  this.resultService.create(this.answers, COMP, this.is_partial).subscribe( data => {
      this.loading=false;
          if (this.is_partial == "false")
            this.alertService.success("Form Submitted Successfully");
          else
            this.alertService.success("Form Saved Successfully");
            
          this.f.form.markAsPristine();
          this.last_saved = new Date();
          window.scroll(0,0);
    },
    error => {
      this.loading=false;
      this.alertService.error(error);
    });
}

  openGuide(text: string) {
    if (this.guidePanelOpen && this.guideText === (text || '')) {
      this.guidePanelOpen = false;
    } else {
      this.guideText = text || '';
      this.guidePanelOpen = true;
      const div = document.createElement('div');
      div.innerHTML = text || '';
      const anchors = div.querySelectorAll('a');
      this.guideLinks = Array.from(anchors).map(a => ({ url: a.href, label: a.textContent || a.href }));
    }
  }

  closeGuide() {
    this.guidePanelOpen = false;
  }

    genderBtnClick(){
      this.router.navigateByUrl('/sdg/gender')
    }
    quesBtnClick(){
        this.router.navigateByUrl('/sdg/gender-quest')
    }
    dataBtnClick(){
        this.router.navigateByUrl('/sdg/gender-data')
    }
    reportBtnClick(){
        this.router.navigateByUrl('/sdg/gender-report')
    }

}
function getRndInteger(min, max) {
    return Math.floor(Math.random() * (max - min) ) + min;
}



// WEBPACK FOOTER //
// ./src/app/sdg/gender-quest/gender-quest.component.ts